import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const processed = useRef(false);
  const [err, setErr] = useState("");
  const { refresh } = useAuth();

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login");
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id });
        // Persist session_token as Bearer fallback too
        if (r.data?.session_token) {
          localStorage.setItem("bfx_token", r.data.session_token);
        }
        await refresh();
        nav("/", { replace: true });
      } catch (e) {
        setErr("Falha ao processar autenticação");
        setTimeout(() => nav("/login"), 2000);
      }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen grid place-items-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-brand-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-ink-secondary">{err || "Autenticando..."}</p>
      </div>
    </div>
  );
}
